<div
  class="message-container"
  *ngIf="!closed"
  [ngClass]="type">
  <p>{{ messageCode | transloco }}</p>
  <div class="message-buttons">
    <ng-content #cta></ng-content>
    <ui-icon
      class="close-icon"
      *ngIf="hasCloseBtn"
      [key]="'close'"
      (click)="close()"></ui-icon>
  </div>
</div>
